/* global Plotly:true */

import React, { Component } from "react";
import createPlotlyComponent from "react-plotly.js/factory";

const Plot = createPlotlyComponent(Plotly);

export default class CurrentHospitalized extends Component {
  render() {
    return (
      <div>
        <h4 style={{ marginBottom: "-52px" }}>Currently hospitalized</h4>
        <Plot
          data={[
            {
              meta: { columnNames: { x: "A", y: "B" } },
              mode: "markers",
              type: "bar",
              xsrc: "AlejandroGalavizSalazar:0:4f5e9d",
              x: this.props.newDates,
              ysrc: "AlejandroGalavizSalazar:0:f25925",
              y: this.props.currentHosp,
              name: "<b>Currently hospitalized</b>",
              marker: { color: "rgb(0, 67, 153)", opacity: 1 },
              opacity: 0.4,
              showlegend: true,
              orientation: "v",
            },
            {
              line: { color: "rgb(0, 67, 153)", width: 4 },
              meta: { columnNames: { x: "A", y: "C" } },
              mode: "lines",
              type: "scatter",
              xsrc: "AlejandroGalavizSalazar:0:4f5e9d",
              name: "<b>Hospitalized (7 day avg.)</b>",
              x: this.props.newDates,
              ysrc: "AlejandroGalavizSalazar:0:f0c424",
              y: this.props.currentHMA,
              showlegend: true,
              orientation: "v",
            },
          ]}
          layout={{
            width: 873,
            height: 600,
            title: {
              text:
                "<b style='font-size:32px;color:black'>Currently hospitalized</b>",
            },
            xaxis: {
              type: "category",
              range: [-0.5, 146.5],
              nticks: 6,
              autorange: true,
            },
            yaxis: {
              type: "linear",
              range: [0, 3702.1052631578946],
              autorange: true,
              title: {
                font: { size: 18, color: "rgb(0, 67, 153)" },
                text: "<b>Hospitalized</b>",
              },
            },

            legend: {
              x: -0.007773445004434956,
              y: 1.1298744801596714,
              font: { size: 15 },
            },
            autosize: true,
            template: {
              data: {
                bar: [
                  {
                    type: "bar",
                    marker: { colorbar: { ticks: "", outlinewidth: 0 } },
                  },
                ],
                table: [
                  {
                    type: "table",
                    cells: {
                      fill: { color: "#e8ebef" },
                      line: { color: "white" },
                    },
                    header: {
                      fill: { color: "#C8D4E3" },
                      line: { color: "white" },
                    },
                  },
                ],
                carpet: [
                  {
                    type: "carpet",
                    aaxis: {
                      gridcolor: "#C8D4E3",
                      linecolor: "#C8D4E3",
                      endlinecolor: "#2a3f5f",
                      minorgridcolor: "#C8D4E3",
                      startlinecolor: "#2a3f5f",
                    },
                    baxis: {
                      gridcolor: "#C8D4E3",
                      linecolor: "#C8D4E3",
                      endlinecolor: "#2a3f5f",
                      minorgridcolor: "#C8D4E3",
                      startlinecolor: "#2a3f5f",
                    },
                  },
                ],
                mesh3d: [
                  {
                    type: "mesh3d",
                    colorbar: { ticks: "", outlinewidth: 0 },
                  },
                ],
                contour: [
                  {
                    type: "contour",
                    colorbar: { ticks: "", outlinewidth: 0 },
                    autocolorscale: true,
                  },
                ],
                heatmap: [
                  {
                    type: "heatmap",
                    colorbar: { ticks: "", outlinewidth: 0 },
                    autocolorscale: true,
                  },
                ],
                scatter: [
                  {
                    type: "scatter",
                    marker: { colorbar: { ticks: "", outlinewidth: 0 } },
                  },
                ],
                surface: [
                  {
                    type: "surface",
                    colorbar: { ticks: "", outlinewidth: 0 },
                  },
                ],
                heatmapgl: [
                  {
                    type: "heatmapgl",
                    colorbar: { ticks: "", outlinewidth: 0 },
                  },
                ],
                histogram: [
                  {
                    type: "histogram",
                    marker: { colorbar: { ticks: "", outlinewidth: 0 } },
                  },
                ],
                parcoords: [
                  {
                    line: { colorbar: { ticks: "", outlinewidth: 0 } },
                    type: "parcoords",
                  },
                ],
                scatter3d: [
                  {
                    type: "scatter3d",
                    marker: { colorbar: { ticks: "", outlinewidth: 0 } },
                  },
                ],
                scattergl: [
                  {
                    type: "scattergl",
                    marker: { colorbar: { ticks: "", outlinewidth: 0 } },
                  },
                ],
                choropleth: [
                  {
                    type: "choropleth",
                    colorbar: { ticks: "", outlinewidth: 0 },
                  },
                ],
                scattergeo: [
                  {
                    type: "scattergeo",
                    marker: { colorbar: { ticks: "", outlinewidth: 0 } },
                  },
                ],
                histogram2d: [
                  {
                    type: "histogram2d",
                    colorbar: { ticks: "", outlinewidth: 0 },
                    autocolorscale: true,
                  },
                ],
                scatterpolar: [
                  {
                    type: "scatterpolar",
                    marker: { colorbar: { ticks: "", outlinewidth: 0 } },
                  },
                ],
                contourcarpet: [
                  {
                    type: "contourcarpet",
                    colorbar: { ticks: "", outlinewidth: 0 },
                  },
                ],
                scattercarpet: [
                  {
                    type: "scattercarpet",
                    marker: { colorbar: { ticks: "", outlinewidth: 0 } },
                  },
                ],
                scattermapbox: [
                  {
                    type: "scattermapbox",
                    marker: { colorbar: { ticks: "", outlinewidth: 0 } },
                  },
                ],
                scatterpolargl: [
                  {
                    type: "scatterpolargl",
                    marker: { colorbar: { ticks: "", outlinewidth: 0 } },
                  },
                ],
                scatterternary: [
                  {
                    type: "scatterternary",
                    marker: { colorbar: { ticks: "", outlinewidth: 0 } },
                  },
                ],
                histogram2dcontour: [
                  {
                    type: "histogram2dcontour",
                    colorbar: { ticks: "", outlinewidth: 0 },
                    autocolorscale: true,
                  },
                ],
              },
              layout: {
                geo: {
                  bgcolor: "white",
                  showland: true,
                  lakecolor: "white",
                  landcolor: "white",
                  showlakes: true,
                  subunitcolor: "#C8D4E3",
                },
                font: { color: "#2a3f5f" },
                polar: {
                  bgcolor: "white",
                  radialaxis: {
                    ticks: "",
                    gridcolor: "#e8ebef",
                    linecolor: "#e8ebef",
                  },
                  angularaxis: {
                    ticks: "",
                    gridcolor: "#e8ebef",
                    linecolor: "#e8ebef",
                  },
                },
                scene: {
                  xaxis: {
                    ticks: "",
                    gridcolor: "#DFE8F3",
                    gridwidth: 2,
                    linecolor: "#e8ebef",
                    zerolinecolor: "#e8ebef",
                    showbackground: true,
                    backgroundcolor: "white",
                  },
                  yaxis: {
                    ticks: "",
                    gridcolor: "#DFE8F3",
                    gridwidth: 2,
                    linecolor: "#e8ebef",
                    zerolinecolor: "#e8ebef",
                    showbackground: true,
                    backgroundcolor: "white",
                  },
                  zaxis: {
                    ticks: "",
                    gridcolor: "#DFE8F3",
                    gridwidth: 2,
                    linecolor: "#e8ebef",
                    zerolinecolor: "#e8ebef",
                    showbackground: true,
                    backgroundcolor: "white",
                  },
                },
                title: { x: 0.05 },
                xaxis: {
                  ticks: "",
                  gridcolor: "#e8ebef",
                  linecolor: "#e8ebef",
                  automargin: true,
                  zerolinecolor: "#e8ebef",
                  zerolinewidth: 2,
                },
                yaxis: {
                  ticks: "",
                  gridcolor: "#e8ebef",
                  linecolor: "#e8ebef",
                  automargin: true,
                  zerolinecolor: "#e8ebef",
                  zerolinewidth: 2,
                },
                ternary: {
                  aaxis: {
                    ticks: "",
                    gridcolor: "#DFE8F3",
                    linecolor: "#A2B1C6",
                  },
                  baxis: {
                    ticks: "",
                    gridcolor: "#DFE8F3",
                    linecolor: "#A2B1C6",
                  },
                  caxis: {
                    ticks: "",
                    gridcolor: "#DFE8F3",
                    linecolor: "#A2B1C6",
                  },
                  bgcolor: "white",
                },
                colorway: [
                  "#636efa",
                  "#EF553B",
                  "#00cc96",
                  "#ab63fa",
                  "#19d3f3",
                  "#e763fa",
                  "#fecb52",
                  "#ffa15a",
                  "#ff6692",
                  "#b6e880",
                ],
                hovermode: "closest",
                colorscale: {
                  diverging: [
                    [0, "#8e0152"],
                    [0.1, "#c51b7d"],
                    [0.2, "#de77ae"],
                    [0.3, "#f1b6da"],
                    [0.4, "#fde0ef"],
                    [0.5, "#f7f7f7"],
                    [0.6, "#e6f5d0"],
                    [0.7, "#b8e186"],
                    [0.8, "#7fbc41"],
                    [0.9, "#4d9221"],
                    [1, "#276419"],
                  ],
                  sequential: [
                    [0, "#0508b8"],
                    [0.0893854748603352, "#1910d8"],
                    [0.1787709497206704, "#3c19f0"],
                    [0.2681564245810056, "#6b1cfb"],
                    [0.3575418994413408, "#981cfd"],
                    [0.44692737430167595, "#bf1cfd"],
                    [0.5363128491620112, "#dd2bfd"],
                    [0.6256983240223464, "#f246fe"],
                    [0.7150837988826816, "#fc67fd"],
                    [0.8044692737430168, "#fe88fc"],
                    [0.8938547486033519, "#fea5fd"],
                    [0.9832402234636871, "#febefe"],
                    [1, "#fec3fe"],
                  ],
                  sequentialminus: [
                    [0, "#0508b8"],
                    [0.0893854748603352, "#1910d8"],
                    [0.1787709497206704, "#3c19f0"],
                    [0.2681564245810056, "#6b1cfb"],
                    [0.3575418994413408, "#981cfd"],
                    [0.44692737430167595, "#bf1cfd"],
                    [0.5363128491620112, "#dd2bfd"],
                    [0.6256983240223464, "#f246fe"],
                    [0.7150837988826816, "#fc67fd"],
                    [0.8044692737430168, "#fe88fc"],
                    [0.8938547486033519, "#fea5fd"],
                    [0.9832402234636871, "#febefe"],
                    [1, "#fec3fe"],
                  ],
                },
                plot_bgcolor: "white",
                paper_bgcolor: "white",
                shapedefaults: {
                  line: { width: 0 },
                  opacity: 0.4,
                  fillcolor: "#506784",
                },
                annotationdefaults: {
                  arrowhead: 0,
                  arrowcolor: "#506784",
                  arrowwidth: 1,
                },
              },
              themeRef: "PLOTLY_WHITE",
            },
            showlegend: true,
          }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/graphs/az/CurrentHospitalized.js